import createLucideIcon from '../createLucideIcon';

const Moon = createLucideIcon('Moon', [
  ['path', { d: 'M12 3a6.364 6.364 0 0 0 9 9 9 9 0 1 1-9-9Z', key: '1rit1i' }],
]);

export default Moon;
